import classNames from 'classnames';
import React from 'react';
import s from './message-list.module.scss';
import { IconCheck, IconChecks, IconClock, IconAlertCircle } from '@tabler/icons-react';
import { isImage } from '@utils/lib/isImage';
import { Images } from '@features/messanger/ui/images';
import { downloadFile } from '@utils/lib/downloadFile';
import { getFileTypeIcon } from '@utils/lib/fileTypesIcons';
import { formatFileSize } from '@utils/lib/formatFileSize';
import { formatMessageTime, isInteractiveMessage } from '@entities/messanger';
import { useReadMessage } from '@features/messanger/read-message';
import { InteractiveMessage } from '@features/messanger/interactive-message';
import { MarkdownText } from '@shared/lib/markdown';

export const MessageItem = React.memo(({ message, isMine, onRead }) => {
  const ref = useReadMessage(message, isMine ? null : onRead);

  const timeString = formatMessageTime(message.timestamp);
  const isInteractive = isInteractiveMessage(message);
  const hasText = !isInteractive && !!message.data;
  const attachment = message.attachments?.[0];
  const isImageAttachment = !isInteractive && attachment && isImage(attachment);

  return (
    <div
      className={classNames(
        s.message,
        isMine && s.mine,
        isInteractive && s.interactive,
        isImageAttachment && !hasText && s.onlyImg,
        message.pending && s.pending,
        message.failed && s.failed
      )}
      ref={ref}
    >
      {isImageAttachment && (
        <Images className={isImageAttachment && !hasText && s.onlyImg} images={[process.env.REACT_APP_STORAGE_URL + attachment.file]} />
      )}
      <div className={s.flex}>
        <span className={s.textWrapper}>
          {isInteractive && <InteractiveMessage message={message} isMine={isMine} />}
          {hasText && <MarkdownText className={s.text} text={message.data} />}
          {/* {hasText && <span className={s.text}>{message.data}</span>} */}
          {attachment && !isImageAttachment && (
            <div className={s.fileBlock}>
              <div
                className={s.fileIcon}
                onClick={() =>
                  attachment.file
                    ? downloadFile(process.env.REACT_APP_STORAGE_URL + attachment.file)
                    : null
                }
              >
                {getFileTypeIcon(attachment.name?.split('.').pop() || 'file')}
              </div>
              <div className={s.fileInfo}>
                <div
                  onClick={() =>
                    attachment.file
                      ? downloadFile(process.env.REACT_APP_STORAGE_URL + attachment.file)
                      : null
                  }
                  className={s.fileName}
                >
                  {attachment.name}
                </div>
                {attachment.size && (
                  <p className={s.fileSize}>{formatFileSize(attachment.size)}</p>
                )}
              </div>
            </div>
          )}
        </span>
        <span className={s.timestamp}>
          {timeString}
          {isMine && (
            <>
              {message.pending && <IconClock size={14} className={s.pendingIcon} />}
              {message.failed && <IconAlertCircle size={14} className={s.failedIcon} />}
              {!message.pending && !message.failed && (
                message.is_read
                  ? <IconChecks className={s.readIcon} size={14} />
                  : <IconCheck className={s.unreadIcon} size={14} />
              )}
            </>
          )}
        </span>
      </div>
    </div>
  );
});
